export const LEAD_STATUS = {
  WAITING: 'WAITING',
  ACCEPTED: 'ACCEPTED',
  REFUSED: 'REFUSED',
  WON: 'WON',
  LOST: 'LOST',
} as const

export type LeadStatus = (typeof LEAD_STATUS)[keyof typeof LEAD_STATUS]

export const LEAD_STATUS_LABELS: Record<LeadStatus, string> = {
  [LEAD_STATUS.WAITING]: 'En attente',
  [LEAD_STATUS.ACCEPTED]: 'Accepté',
  [LEAD_STATUS.REFUSED]: 'Refusé',
  [LEAD_STATUS.WON]: 'Gagné',
  [LEAD_STATUS.LOST]: 'Perdu',
}
